export default __webpack_public_path__ + "media/1040eb03906b1b319e34e79722523eaee157452a4145a30449bcdc6adc0abfdb.svg";